// hooks/useLhForm.js

// 현재 값 불러오기
export function getIsLh() {
  return localStorage.getItem('isLh') === 'true';
}

export function getSiteId() {
  return localStorage.getItem('siteId') || '';
}

// 값 설정
export function setIsLh(value) {
  localStorage.setItem('isLh', String(value));
}

export function setSiteId(value) {
  localStorage.setItem('siteId', value);
}
